import { getTimeslots } from 'entities/toolbar/timeslots';
import { formatWithLocale } from 'shared/lib/datepicker/helpers/dateHelper';
import { useAppDispatch } from 'shared/lib/store';

export const useGetSlotsByDate = () => {
	const dispatch = useAppDispatch();
	const getSlotsByDate = (date: Date) => {
		return dispatch(getTimeslots({
			date_slot: formatWithLocale(date, 'yyyy-MM-dd'),
		}));
	};

	return { getSlotsByDate };
};
